'use client';

import { ReactNode } from 'react';

import { Box, BoxContent, TrilogyColor } from '@bytel/trilogy-react';

interface BoxInfoProps {
    children: ReactNode;
    header: ReactNode;
}

export function BoxInfo({ children, header }: Readonly<BoxInfoProps>) {
    return (
        <Box shadowless flat fullheight className='is-fullwidth'>
            <BoxContent backgroundColor={TrilogyColor.MAIN} className='is-growless'>
                {header}
            </BoxContent>
            <BoxContent>{children}</BoxContent>
        </Box>
    );
}
